// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const ActionsheetScrollView = createStyle({
  w: '$full',
  h: 'auto',
});
